module.exports = __webpack_public_path__ + "img/world-map-md.db583904.png";